module.exports = __webpack_public_path__ + "static/media/kiwi-picker-robotics-twitter.1f01b020.jpg";